var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SignFileWrap',[_c('div',{staticClass:"catFile"},[_c('iframe',{staticClass:"doc-iframe",style:({
        width: `100%`,
        height: `100vh`,
      }),attrs:{"srcdoc":_vm.currentFile.fileHtml,"frameborder":"0","id":"MyIFrame"}}),_c('div',{staticClass:"footer"},[_c('div',{staticClass:"btn",on:{"click":_vm.onClick}},[_vm._v("填写文件内容")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }